import React from 'react';
import { Card } from '@/components/ui/card';
import { MapPin, ChevronRight } from 'lucide-react';

export default function LocationsList({ locations, selectedLocation, onSelect }) {
  return (
    <div className="lg:col-span-1 space-y-4">
      <h2 className="text-lg font-bold mb-4">All Branches ({locations.length})</h2>
      {locations.map((location) => (
        <Card
          key={location.id}
          data-testid="location-card"
          className={`p-4 cursor-pointer transition-all hover:shadow-lg ${
            selectedLocation?.id === location.id ? 'ring-2 ring-primary' : ''
          } ${!location.active ? 'opacity-60' : ''}`}
          onClick={() => onSelect(location)}
        >
          <div className="flex items-start gap-3">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${
              location.active ? 'bg-accent' : 'bg-muted'
            }`}>
              <MapPin className={`w-5 h-5 ${location.active ? 'text-accent-foreground' : 'text-muted-foreground'}`} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <h3 className="font-bold truncate">{location.name}</h3>
                {!location.active && (
                  <span className="text-xs bg-destructive/10 text-destructive px-2 py-0.5 rounded-full">
                    Inactive
                  </span>
                )}
              </div>
              <p className="text-sm text-muted-foreground truncate">{location.address}</p>
              <p className="text-xs text-muted-foreground mt-1">
                {location.courts_count} courts • {(location.sports || []).join(', ')}
              </p>
            </div>
            <ChevronRight className="w-5 h-5 text-muted-foreground flex-shrink-0" />
          </div>
        </Card>
      ))}
    </div>
  );
}
